import React from 'react'
import Breadcrumb from '../../core/components/UI/Breadcrumb'
import useMineralCountryDetails from '../hooks/useMineralCountryDetails'
import { useCountryContext } from '../../core/context/country/CountryProvider'
import { useMineralContext } from '../context/mineral/mineralProvider'
import FormEditMineralDetails from '../components/mineral-edit-dage/FormEditMineral'
import FormEditMineral from '../components/mineral-edit-dage/FormEditMineral'
import LoaderEditMineralForm from '../components/mineral-edit-dage/LoaderEditMineralForm'

export default function MineralEditPage() {
  const { mineralState } = useMineralContext()

  return (
    <>
      <Breadcrumb
        links={[
          {
            id: 1,
            label: 'المعادن',
            isActive: false,
            to: '/minerals',
          },
          {
            id: 2,
            label: mineralState.mineral?.name_ar,
            isActive: false,
            to: `/minerals/${mineralState.mineral?.id}`,
          },
          {
            id: 5,
            label: 'تعديل',
            isActive: true,
          },
        ]}
      />
      <div className="border-2 border-muted-500 bg-white p-2">
        {mineralState.isLoading ? (
          <LoaderEditMineralForm />
        ) : (
          <FormEditMineral mineral={mineralState.mineral} />
        )}
      </div>
    </>
  )
}
